import {
  TaskCardType,
  taskCardTypeSchema,
} from '@/task-manager/entities/task-card-type';

export function taskCardTypeMapper(data: string): TaskCardType {
  return taskCardTypeSchema.parse(data);
}
